import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

import {Role} from '../models/role.model';

export class GetRolesCommand extends GetListAPICommand<Role> {
  constructor(apiService: ApiService, adapter: IAdapter<Role>) {
    super(apiService, adapter, `${environment.userApiUrl}/roles`);
  }
}
